import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { BankaccountModel } from '../models/bankaccount.model'
import { BankaccountResponseModel } from '../models/bankaccount-response.model'

@Injectable()
export class BankaccountsService implements Resolve<Observable<any>> {
  private readonly url = environment.base_url + '/v2/support/administration'

  private bankAccount: BankaccountModel
  private bankAccounts: BankaccountResponseModel

  bankAccountsChanged: BehaviorSubject<BankaccountResponseModel> = new BehaviorSubject<BankaccountResponseModel>(
    undefined,
  )
  bankAccountChanged: BehaviorSubject<BankaccountModel> = new BehaviorSubject<BankaccountModel>(undefined)

  constructor(private _httpClient: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const bankAccountId = route.params['bankAccountId']
    const administrationId = route.params['administrationId']

    if (bankAccountId) {
      return this.read(administrationId, bankAccountId)
    } else {
      return this.browse(administrationId)
    }
  }

  /**
   *
   * @param administrationId
   */
  browse(administrationId: number) {
    return this._httpClient.get<BankaccountResponseModel>(`${this.url}/${administrationId}/bank-accounts`).map(data => {
      this.bankAccounts = new BankaccountResponseModel(data)
      this.bankAccountsChanged.next(this.bankAccounts)
      return this.bankAccounts
    })
  }

  /**
   *
   * @param administrationId
   * @param bankAccountId
   */
  read(administrationId, bankAccountId): Observable<BankaccountModel> {
    return this._httpClient
      .get<BankaccountModel>(`${this.url}/${administrationId}/bank-accounts/${bankAccountId}`)
      .filter(bankAccount => !!bankAccount)
      .map(bankAccount => {
        this.bankAccount = new BankaccountModel(bankAccount)
        this.bankAccountChanged.next(this.bankAccount)
        return this.bankAccount
      })
  }

  /**
   *
   * @param data
   * @param administrationId
   */
  create(data, administrationId): Observable<BankaccountModel> {
    return this._httpClient.post<BankaccountModel>(`${this.url}/${administrationId}/bank-accounts`, data).do(() => {
      this.browse(administrationId).subscribe()
    })
  }

  update(bankAccount: BankaccountModel, administrationId): Observable<BankaccountModel> {
    return this._httpClient
      .put<BankaccountModel>(`${this.url}/${administrationId}/bank-accounts/${bankAccount.id}`, bankAccount)
      .do(() => {
        this.browse(administrationId).subscribe()
      })
  }

  /**
   * Deletes a bankaccount
   * @param bankAccountId
   * @param administrationId
   */
  delete(bankAccountId: number, administrationId: number): Observable<BankaccountResponseModel> {
    return this._httpClient
      .delete<void>(`${this.url}/${administrationId}/bank-accounts/${bankAccountId}`)
      .flatMap(e => this.browse(administrationId))
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/bankaccounts.service.ts